import React from 'react';
const SendArrowIcon = () => (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M9.66736 3.00098L14.6673 8.00094L9.66736 13.0009M14.6673 8.00094L1.33398 8.00076", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
export default SendArrowIcon;
